// Polyfills
import 'polyfills/performance.now-polyfill.js';
import 'polyfills/requestAnimationFrame-polyfill.js';

// core-js polyfills
import 'core-js/actual/string/replace-all';

// Libraries
import React from 'react';
import mixpanel from 'mixpanel-browser';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
// Components
import App from 'containers/App';

// Dependencies
import store from 'store/store';
import { initSentry } from 'utils/sentry';
import { storeQueryParamToken } from 'services/utils/accessToken';

// Initialize query param token detection on app mount
storeQueryParamToken();

// Mixpanel setup
const TESTING_MIXPANEL = '1e95f0763403422ce489e515953f0cd1';
const PRODUCTION_MIXPANEL = '33a3f6524d997236772624270e642baf';
if (window.env === 'dev') {
  mixpanel.init(TESTING_MIXPANEL);
}
if (window.env === 'production') {
  mixpanel.init(PRODUCTION_MIXPANEL);

  // Initialize Sentry with optimized configuration
  initSentry();
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
